import PropTypes from 'prop-types';
import React from 'react';
import {Button, Form, FormGroup, Input, Label} from 'reactstrap';
import {AuthConsumer} from '../utils/AuthContext';
import Global from '../utils/Global';
import BaseComponent from './BaseComponent';
import {getData, storeData} from '../utils/StorageUtil';
import Img from 'react-image';
import catchadealLogo from 'assets/img/logo/ic_logo_abacus.png';
// import label from '../message/Label'
import label from 'enqc-utilities/src/label/Label'
import {isEmpty, isValidEmail} from "../utils/Utilities";
import WarningLabel from "./Widget/WarningLabel";
import Endpoint from "enqc-utilities/src/api/Endpoint";

class AuthForm extends BaseComponent {

  constructor(props, context) {
    super(props, context);

    this.handleSubmit = this.handleSubmit.bind(this);
    let state = this.state
    state.email = Global.DEV_LOGIN_USERNAME
    state.password = Global.DEV_LOGIN_PASSWORD
    state.configuration = getData(Global.CONFIGURATION)
    state.configurationAdmin = getData(Global.CONFIGURATION_ADMIN)
    state.message = this.props.message
  }

  componentDidMount() {
    super.componentDidMount();
    this.fetchAppSetting()
    // this.fetchConfigurationAdmin()
  }

  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }

  get isSignup() {
    return this.props.authState === STATE_SIGNUP;
  }

  changeAuthState = authState => event => {
    event.preventDefault();

    this.props.onChangeAuthState(authState);
  };

  handleSubmit = async (event, authProps) => {
    event.preventDefault();
    const { executeRecaptcha } = this.props;
    if(isEmpty(this.state.email) || isEmpty(this.state.password)){
      this.setState({
        message : label.PleaseCompleteTheFields
      })
      return ;
    }
    if(!isValidEmail(this.state.email)){
      this.setState({
        message : label.InvalidEmailAddress
      })
      return;
    }
    if(this.isLogin){
      this.showProgress()
      const token = await executeRecaptcha("login_action");
      this.closeProgress()
      this.post(Endpoint.API.ADMIN_LOGIN, null, {
        params:{
          email:this.state.email,
          password:this.state.password,
        },
        headers:{
          grt:token
        }
      }, response=>{
        this.closeProgress()
        if(response.code===200){
          const admin = response.data ;
          storeData(Global.AUTHORIZATION, response.data.authorization)
          authProps.login(admin)
        }else{
          console.error(response.message)
          this.setState({
            message :response.message
          }, () => {
            this.forceUpdate()
          })
        }
      }, true, false)
    }
  };

  renderButtonText() {
    const { buttonText } = this.props;

    if (!buttonText && this.isLogin) {
      return label.LOGIN;
    }

    if (!buttonText && this.isSignup) {
      return label.SIGNUP;
    }

    return buttonText;
  }

  fetchAppSetting=()=>{
    this.get(Global.API.CONFIGURATION_CURRENT_ACTIVE, null, null, response=>{
      if(response.code===200){
        let configuration = response.data
        storeData(Global.CONFIGURATION, configuration)
        this.setState({
          configuration:configuration
        })
      }
    })
  }

  fetchConfigurationAdmin=()=>{
    this.get(Global.API.CONFIGURATION_ADMIN, null, null, response=>{
      if(response.code===200){
        let configurationAdmin = response.data
        storeData(Global.CONFIGURATION_ADMIN, configurationAdmin)
        this.setState({
          configurationAdmin:configurationAdmin
        })
      }
    })
  }


  render() {
    const {
      showLogo,
      usernameLabel,
      usernameInputProps,
      passwordLabel,
      passwordInputProps,
      confirmPasswordLabel,
      confirmPasswordInputProps,
      children,
      onLogoClick,
    } = this.props;

    let configuration = this.state.configuration
    if(!configuration){
      configuration = {}
    }
    let {message} = this.state


    const baseRender = super.render();
    return (
          <AuthConsumer>
            {
              (authProps) => (
                  <div>
                    {baseRender}
                    {showLogo && (
                        <div className="text-center pb-4" style={{marginTop:'50px', paddingTop:'20px'}}>
                          <Img
                              src={catchadealLogo}
                              className="rounded"
                              style={{width:'70%', height:'30%'}}
                              alt="logo"
                              onClick={onLogoClick}
                          />
                        </div>
                    )}
                    <div style={{display:'block', textAlign:"center"}}>
                      <h1>{label.Administrator}</h1>
                    </div>
                    <Form onSubmit={async (e)=>{
                      await this.handleSubmit(e,authProps)
                    }}>
                      <br/>
                      <FormGroup>
                        <Label for={usernameLabel}>{usernameLabel}</Label>
                        <Input {...usernameInputProps} value={this.state.email} onChange={e=>{this.setState({email:e.target.value})}}/>
                      </FormGroup>
                      <FormGroup>
                        <Label for={passwordLabel}>{passwordLabel}</Label>
                        <Input {...passwordInputProps} value={this.state.password} onChange={e=>{this.setState({password:e.target.value})}}
                               onKeyDown={async (e)=>{
                          // alert(e.key)
                          if(e.key==='Enter'){
                            e.preventDefault()
                            await this.handleSubmit(e, authProps)
                          }
                        }} />
                      </FormGroup>
                      {this.isSignup && (
                          <FormGroup>
                            <Label for={confirmPasswordLabel}>{confirmPasswordLabel}</Label>
                            <Input {...confirmPasswordInputProps} value={this.state.password} onChange={e=>{this.setState({password:e.value})}}/>
                          </FormGroup>
                      )}
                      <hr />
                      {message&&(
                          <>
                            <WarningLabel style={{textAlign:'center', fontSize:'14px'}} show={message} message={message}/>
                            <hr />
                          </>
                      )}
                      <Button
                          size="lg"
                          block
                          color={"primary"}
                          onClick={async (e)=>{
                            await this.handleSubmit(e, authProps)
                          }}>
                        {this.renderButtonText()}
                      </Button>
                      {children}
                    </Form>

                  </div>
              )
            }
          </AuthConsumer>
    );
  }
}

export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usernameLabel: PropTypes.string,
  usernameInputProps: PropTypes.object,
  passwordLabel: PropTypes.string,
  passwordInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func,
  message:PropTypes.string,
};

AuthForm.defaultProps = {
  authState: 'LOGIN',
  showLogo: true,
  usernameLabel: label.Email,
  usernameInputProps: {
    type: 'email',
    placeholder: label.EnterEmail,
  },
  passwordLabel: label.Password,
  passwordInputProps: {
    type: 'password',
    placeholder: label.EnterPassword,
  },
  confirmPasswordLabel: label.ConfirmPassword,
  confirmPasswordInputProps: {
    type: 'password',
    placeholder: label.EnterConfirmPassword,
  },
  onLogoClick: () => {},
};

export default AuthForm;
